import React from 'react';
import { useAppContext } from '../../../../../AppContext';
import styled, { css } from 'styled-components';
import styles from './Header.module.scss';
// @ts-ignore
import classNames from 'classnames';
import { StyleService } from '../../../../services';
import { DictionaryType } from '../../../../types/DictionaryType';

type PropsType = {
  title?: string;
  children?: React.ReactNode;
  classNames?: string;
  id?: string;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const Header = (props: PropsType) => {
  const context = useAppContext();
  const whitelabelingStyles = StyleService.apply(
    'module:container:header',
    context.styles
  );
  const HeadingTag = props.headingLevel ?? 'h1';

  return (
    <HeaderDiv
      className={classNames(styles.wrapper, props.classNames)}
      styles={whitelabelingStyles}
      id={props.id}
    >
      {props.title && <HeadingTag className={styles.title}>{props.title}</HeadingTag>}
      {props.children}
    </HeaderDiv>
  );
};

const HeaderDiv = styled.section<{ styles: DictionaryType<string> }>`
  ${(props) => css`
    --module-header-background-color: ${props.styles.backgroundColor};
    --module-header-text-color: ${props.styles.textColor};
  `}
`;

export default Header;
